<template>
  <div
    class="login-page"
    :class="{ 'without-college-logo': collegeName[productId].showLogo === false }"
  >
    <!-- 头部banner区域 -->
    <div class="header-banner">
      <div class="banner-content">
        <img
          src="@/assets/college/bg-banner.png"
          class="banner-image"
        />
        <!-- 原 Logo 模板保留，恢复方式见 college/config.js 的 showShandongUniversityLogo 开关。 -->
        <div
          v-if="collegeName[productId].showLogo !== false"
          class="logo-section"
        >
          <img
            :src="collegeName[productId].loginLogo"
            :alt="collegeName[productId].name"
            class="university-logo"
          />
        </div>
      </div>
    </div>

    <!-- 登录表单区域 -->
    <div class="login-form-container">
      <div class="form-card">
        <h2 class="form-title">新未来健康工程</h2>

        <form @submit.prevent="handleLogin" class="login-form">
          <!-- 手机号输入 -->
          <div class="form-group">
            <input
              type="tel"
              v-model="loginForm.phone"
              placeholder="请输入手机号"
              class="form-input"
              maxlength="11"
              @input="validatePhone"
            />
          </div>

          <!-- 验证码输入 -->
          <div class="form-group verification-group">
            <input
              type="text"
              v-model="loginForm.code"
              placeholder="请输入验证码"
              class="form-input verification-input"
              maxlength="6"
            />
            <button
              type="button"
              class="get-code-btn"
              :disabled="!canGetCode"
              @click="getVerificationCode"
            >
              {{ codeButtonText }}
            </button>
          </div>

          <!-- 协议同意 -->
          <div class="agreement-section">
            <van-checkbox
              v-model="loginForm.agreed"
              checked-color="#FF2025"
              icon-size="16px"
            ></van-checkbox>
            <div>
              <span class="gray">我已阅读并同意</span>
              <span
                v-for="(item, index) in agreementList"
                :key="index"
                @click="onHanldeShowAgreement(index)"
                >{{ item.lable }}</span
              >
            </div>
          </div>

          <!-- 登录按钮 -->
          <button
            type="submit"
            class="login-btn"
            :disabled="!canLogin"
            :class="{ disabled: !canLogin }"
          >
            登录
          </button>
        </form>
      </div>
    </div>

    <!-- 协议弹窗 -->
    <van-popup
      v-model="showFlag"
      round
      closeable
      position="bottom"
      close-icon="close"
      :style="{ height: '50%' }"
    >
      <div class="text-dialog flex flex-column">
        <h2>{{ finnalAgreement.title }}</h2>
        <div class="text-content flex-1" v-html="finnalAgreement.content"></div>
      </div>
    </van-popup>

    <!-- 角色选择弹窗 -->
    <van-dialog
      v-model="showRoleDialog"
      title="请选择登录身份"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
      class="role-dialog"
    >
      <div class="role-selection">
        <div
          class="role-option"
          :class="{ active: selectedRole === 'client' }"
          @click="selectedRole = 'client'"
        >
          <van-icon name="user-o" size="40" />
          <div class="role-name">客户端</div>
        </div>
        <div
          class="role-option"
          :class="{ active: selectedRole === 'staff' }"
          @click="selectedRole = 'staff'"
        >
          <van-icon name="manager-o" size="40" />
          <div class="role-name">内勤端</div>
        </div>
      </div>
      <div class="role-confirm-btn">
        <van-button
          type="primary"
          block
          :disabled="!selectedRole"
          @click="confirmRole"
        >
          确认
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { onLoginWithPhone, onFetchMessage } from "@/api/client";
import { contents } from "@/utils/util";
import { Dialog } from "vant";
import { college } from "../college/config";


export default {
  name: "ClientLogin",
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      collegeName: college,
      agreementList: [
        {
          lable: "《隐私政策》",
        },
        {
          lable: "《用户注册协议》",
        },
      ],
      finnalAgreement: null,
      showFlag: false,
      loginForm: {
        phone: "",
        code: "",
        agreed: false,
      },
      publicType: "16",
      countdown: 0,
      isLoading: false,
      showRoleDialog: false,
      selectedRole: "",
      loginResponse: null,
      productId: '0',
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productId = urlParams.get("productId") || localStorage.getItem("productId") || "0";

    this.finnalAgreement = contents[0];
    // 检查是否已经登录，如果已登录则跳转到个人中心
    this.checkLoginStatus();
  },
  computed: {
    canGetCode() {
      return this.isValidPhone(this.loginForm.phone) && this.countdown === 0;
    },
    canLogin() {
      return (
        this.isValidPhone(this.loginForm.phone) &&
        this.loginForm.code.length === 6 &&
        this.loginForm.agreed &&
        !this.isLoading
      );
    },
    codeButtonText() {
      return this.countdown > 0 ? `${this.countdown}s后重新获取` : "获取验证码";
    },
  },
  methods: {
    // 检查登录状态
    checkLoginStatus() {
      const clientToken = localStorage.getItem("client_token");
      const medicalToken = localStorage.getItem("medical_university_token");

      if (clientToken) {
        // 客户端已登录，跳转到客户端个人中心
        this.$router.replace({
          path: '/client',
          query: this.$route.query
        });
      } else if (medicalToken) {
        // 内勤端已登录，跳转到内勤端个人中心
        this.$router.replace({
          path: '/medical-university',
          query: this.$route.query
        });
      }
    },
    onHanldeShowAgreement(index) {
      this.finnalAgreement = contents[index];
      this.showFlag = true;
    },
    validatePhone() {
      // 只允许输入数字
      this.loginForm.phone = this.loginForm.phone.replace(/\D/g, "");
    },
    isValidPhone(phone) {
      return /^1[3-9]\d{9}$/.test(phone);
    },
    async getVerificationCode() {
      if (!this.canGetCode) return;

      try {
        // 调用发送验证码API
        const params = {
          userPhone: this.loginForm.phone,
          publicType: this.publicType,
        };

        await onFetchMessage(params);
        this.$toast("验证码已发送");

        // 开始倒计时
        this.countdown = 60;
        const timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(timer);
          }
        }, 1000);
      } catch (error) {
        console.log("获取验证码失败", error);
        this.$toast("获取验证码失败");
      }
    },
    async handleLogin() {
      if (!this.canLogin) return;

      this.isLoading = true;

      try {
        // 调用登录API
        const response = await this.loginApi();
        console.log("response", response);
        if (response.code == 200) {
          // 检查role字段
          if (response.data.role == 2) {
            // 需要选择角色
            this.loginResponse = response;
            this.showRoleDialog = true;
            this.isLoading = false;
          } else if (response.data.role == 0) {
            // 直接进入客户端
            this.handleClientLogin(response);
          } else if (response.data.role == 1) {
            // 进入内勤端
            this.handleStaffLogin(response);
          }
        } else {
          this.$toast(response.msg);
          this.isLoading = false;
        }
      } catch (error) {
        console.log("error", error);
        this.$toast(error.message || "登录失败");
        this.isLoading = false;
      }
    },
    // 调用登录API
    async loginApi() {
      const params = {
        userPhone: this.loginForm.phone,
        publicType: this.publicType,
        // securityCode: '测试验证'
        securityCode: this.loginForm.code,
        productId: this.productId,
      };

      return await onLoginWithPhone(params);
    },
    // 确认角色选择
    confirmRole() {
      if (!this.selectedRole) {
        this.$toast("请选择登录身份");
        return;
      }

      if (this.selectedRole === "client") {
        // 客户端逻辑
        this.handleClientLogin(this.loginResponse);
      } else if (this.selectedRole === "staff") {
        // 内勤端逻辑
        this.handleStaffLogin(this.loginResponse);
      }

      this.showRoleDialog = false;
      this.selectedRole = "";
    },
    // 客户端登录成功处理
    handleClientLogin(response) {
      localStorage.setItem("client_token", response.data.token);
      localStorage.setItem("client_user", response.data.orgName);
      this.$toast("登录成功");
      this.$router.push({
        path: "/client",
        query: {
          productId: this.productId,
        },
      });
      this.isLoading = false;
    },
    // 内勤端登录成功处理
    handleStaffLogin(response) {
      localStorage.setItem("medical_university_token", response.data.token);
      localStorage.setItem("medical_university_user", response.data.orgName);

      // 存储 organizationList 和 haveManyOrg
      if (response.data.organizationList) {
        localStorage.setItem(
          "medical_university_organizationList",
          JSON.stringify(response.data.organizationList)
        );
        // 判断是否有多个组织
        const haveManyOrg =
          Array.isArray(response.data.organizationList) &&
          response.data.organizationList.length > 1;
        localStorage.setItem(
          "medical_university_haveManyOrg",
          haveManyOrg.toString()
        );
      } else {
        // 如果没有 organizationList，清除相关存储
        localStorage.removeItem("medical_university_organizationList");
        localStorage.setItem("medical_university_haveManyOrg", "false");
      }

      this.$toast("登录成功");
      this.$router.push({
        path: "/medical-university",
        query: {
          productId: this.productId,
        },
      });
      this.isLoading = false;
    },
  },
};
</script>

<style scoped src="../college/logo-layout.css"></style>

<style scoped lang="less">
.login-page {
  min-height: 100vh;
  background: #fff;
}

/* 头部banner区域 */
.header-banner {
  position: relative;
  height: 245px;
  overflow: hidden;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

.logo-section {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
}

.university-logo {
  width: 280px;
  display: block;
  margin: 0 auto;
}

.university-info {
  color: white;
}

.university-name {
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #f4ce98;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.university-name-en {
  font-size: 14px;
  margin: 0;
  color: #f4ce98;
  opacity: 0.9;
}

/* 登录表单区域 */
.login-form-container {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
  margin-top: -80px;
}

.form-card {
  background: white;
  border-radius: 20px;
  padding: 40px 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.form-title {
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  color: #4f4f4f;
  margin: 0 0 40px 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 15px 0;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  font-size: 16px;
  background: transparent;
  outline: none;
  transition: border-color 0.3s;
}

.form-input:focus {
  border-bottom-color: #4caf50;
}

.verification-group:focus-within {
  border-bottom-color: #4caf50;
}

.form-input::placeholder {
  color: #999;
}

.verification-group {
  display: flex;
  align-items: flex-end;
  gap: 0;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
}

.verification-input {
  flex: 1;
  border-bottom: none;
}

.get-code-btn {
  padding: 15px 0;
  background: transparent;
  border: none;
  color: #ff4444;
  font-size: 14px;
  cursor: pointer;
  border-bottom: none;
  transition: all 0.3s;
  white-space: nowrap;
  min-width: 100px;
}

.get-code-btn:hover:not(:disabled) {
  color: #ff6666;
}

.get-code-btn:disabled {
  color: #ccc;
  cursor: not-allowed;
}

/* 协议同意 */
.agreement-section {
  margin: 10px 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
}

.agreement-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  line-height: 1.5;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  flex-shrink: 0;
  margin-top: 2px;
}

.checkbox-input:checked + .checkbox-custom {
  background: #4caf50;
  border-color: #4caf50;
}

.checkbox-input:checked + .checkbox-custom::after {
  content: "✓";
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.agreement-text {
  color: #666;
}

.link {
  color: #4caf50;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  line-height: 50px;
  background: linear-gradient(
    268deg,
    rgba(245, 196, 133, 1) 0.61%,
    rgba(254, 221, 189, 1) 97.34%
  );
  border: none;
  border-radius: 50px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(126, 86, 33);
  cursor: pointer;
  transition: all 0.3s;
}

.login-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.login-btn.disabled {
  background: #e0e0e0;
  color: #999;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .banner-content {
    padding: 15px;
  }

  .university-name {
    font-size: 22px;
  }

  .university-name-en {
    font-size: 12px;
  }

  .form-card {
    padding: 30px 20px;
  }

  .form-title {
    font-size: 20px;
  }

  .verification-group {
    flex-direction: row;
    align-items: flex-end;
    gap: 10px;
  }

  .get-code-btn {
    min-width: 80px;
    font-size: 13px;
  }
}

/* 协议弹窗样式 */
.text-dialog {
  padding: 15px;
  height: 100%;
}

.text-dialog h2 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
}

.text-content {
  overflow-y: auto;
  padding: 5px;
  line-height: 1.5;
  font-size: 14px;
}

.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-1 {
  flex: 1;
}

.gray {
  color: #999;
}

.agreement-section span {
  cursor: pointer;
  font-size: 12px;
}
.agreement-section .gray {
  color: #999;
  font-size: 12px;
}

/* 角色选择弹窗样式 */
.role-selection {
  display: flex;
  justify-content: space-around;
  padding: 30px 20px 20px;
  gap: 20px;
}

.role-option {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  border: 2px solid #e5e5e5;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
}

.role-option.active {
  border-color: #c49b45;
  background: #faf7f2;
}

.role-option .van-icon {
  color: #666;
  margin-bottom: 12px;
}

.role-option.active .van-icon {
  color: #c49b45;
}

.role-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.role-option.active .role-name {
  color: #c49b45;
}

.role-confirm-btn {
  padding: 20px;
}

.role-confirm-btn .van-button {
  background: linear-gradient(135deg, #c49b45 0%, #d4af37 100%);
  border: none;
  color: #fff;
  font-weight: 600;
}

.role-confirm-btn .van-button--disabled {
  background: #e0e0e0;
  color: #999;
}
</style>
